import React, { ReactNode, useState, createContext, useContext } from 'react';

export type LoginCaller = 'header' | 'checkout' | null;

interface LoginContextProps {
  caller: LoginCaller;
  setCaller: (caller: LoginCaller) => void;
  clearCaller: () => void;
}

const LoginCallerContext = createContext<LoginContextProps | undefined>(undefined);

export const LoginCallerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [caller, setCallerState] = useState<LoginCaller>(null);

  const setCaller = (newCaller: LoginCaller): void => {
    setCallerState(newCaller);
  };

  const clearCaller = (): void => {
    setCallerState(null);
  };

  return (
    <LoginCallerContext.Provider value={{ caller, setCaller, clearCaller }}>
      {children}
    </LoginCallerContext.Provider>
  );
};

export const useLoginCaller = (): LoginContextProps => {
  const context = useContext(LoginCallerContext);
  if (!context) {
    throw new Error('useLoginCaller must be used within a LoginCallerProvider');
  }
  return context;
};
